import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconRulerMeasure } from '@tabler/icons-react';

/**
 * Used to insert a device measurements placeholder into the editor.
 */
export default function InsertDeviceMeasurementsPlaceholder({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconRulerMeasure />}
      label="Tabuľka meraní"
      onClick={() => {
        editor?.chain().focus().insertDeviceMeasurementsPlaceholder().run();
        window.dispatchEvent(new CustomEvent('open-device-measurements-configurator'));
      }}
    />
  );
}
